/**
 * How a caregiver is related to the patient (#1839, ADR-0042). Labelled
 * Elternteil, Betreuer:in, Partner:in and Sonstige.
 */
export var CaregiverRelationship;
(function (CaregiverRelationship) {
    CaregiverRelationship["PARENT"] = "PARENT";
    CaregiverRelationship["CARER"] = "CARER";
    CaregiverRelationship["PARTNER"] = "PARTNER";
    CaregiverRelationship["OTHER"] = "OTHER";
})(CaregiverRelationship || (CaregiverRelationship = {}));
/**
 * Whether a caregiver entry gives its holder access to the patient (#1840).
 * The same states a patient Person goes through, minus the office-managed one:
 * an entry without access is simply `NONE`. `INVITED` waits for the holder's
 * „Das bin ich“, fresh Account or not; only `REGISTERED` acts for the patient.
 */
export var CaregiverAccessStatus;
(function (CaregiverAccessStatus) {
    CaregiverAccessStatus["NONE"] = "NONE";
    CaregiverAccessStatus["INVITED"] = "INVITED";
    CaregiverAccessStatus["REGISTERED"] = "REGISTERED";
})(CaregiverAccessStatus || (CaregiverAccessStatus = {}));
//# sourceMappingURL=caregiver.enum.js.map